// Redux Utils
import { useDispatch, useSelector } from "react-redux";
import { confirmForgotPassword } from "@/features/forgotPassword/forgotPasswordThunks";
import { fpResetConfirmation } from "@/features/forgotPassword/forgotPasswordSlice";

// React Utils
import React, { useState, useEffect, useRef } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import AppWhoopLogo from "@/assets/appwhoop_ticket_logo.webp";
import ValidateCode from "@/components/ValidateCode";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useSearchParams } from "react-router-dom";
import { motion as Motion, AnimatePresence } from "framer-motion";

export default function ConfirmarCambioDePasswordPorOlvido() {
  // Redux
  const dispatch = useDispatch();
  const { fpconfirmed, fperror } = useSelector((state) => state.forgotPassword);
  const [searchParams] = useSearchParams();
  const codeFromUrl = searchParams.get("code") ?? "";
  const emailFromUrl = searchParams.get("email") ?? "";
  console.log("confirmed:", fpconfirmed);
  console.log("error:", fperror);

  // Estados del formulario
  const [otpCodeisComplete, setOtpCodeisComplete] = useState(false);
  const [otpCode, setOtpCode] = useState("");
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const passwordInputRef = useRef(null);
  const confirmPasswordInputRef = useRef(null);
  const [formData, setFormData] = useState({
    email: emailFromUrl,
    confirmationCode: "",
    password: "",
    confirmPassword: "",
  });

  // Validación del formulario
  const validate = () => {
    const newErrors = {};

    if (!formData.email) {
      newErrors.email = "El correo electrónico es obligatorio";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "El formato del correo electrónico no es válido";
    } else if (formData.email.length > 50) {
      newErrors.email = "El correo no puede tener más de 50 caracteres";
    }

    if (!otpCode || otpCode.length !== 6) {
      newErrors.confirmationCode =
        "El código de confirmación debe tener 6 dígitos";
    }

    // Validaciones de contraseña
    if (!formData.password) {
      newErrors.password = "La contraseña es obligatoria";
    } else {
      if (formData.password.length < 8) {
        newErrors.password = "La contraseña debe tener al menos 8 caracteres";
      } else if (!/[A-Z]/.test(formData.password)) {
        newErrors.password = "La contraseña debe tener al menos una letra mayúscula";
      } else if (!/[a-z]/.test(formData.password)) {
        newErrors.password = "La contraseña debe tener al menos una letra minúscula";
      } else if (!/[0-9]/.test(formData.password)) {
        newErrors.password = "La contraseña debe tener al menos un número";
      } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(formData.password)) {
        newErrors.password = "La contraseña debe tener al menos un símbolo";
      }
    }

    if (!formData.confirmPassword) {
      newErrors.confirmPassword = "Confirmar contraseña es obligatorio";
    } else if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = "Las contraseñas no coinciden";
    }

    // Error específico cuando el código está completo pero falta el email
    if (otpCode.length === 6 && !formData.email.trim()) {
      newErrors.email =
        "Por favor, ingresa tu correo electrónico para continuar";
    }

    return newErrors;
  };

  // Maneja la finalización del código OTP
  const handleOtpComplete = (code) => {
    setFormData({ ...formData, confirmationCode: code });
    // Limpiar errores del código cuando se complete
    if (errors.confirmationCode && code.length === 6) {
      setErrors((prev) => ({ ...prev, confirmationCode: "" }));
    }
  };

  // Maneja cambios en el input de email
  const handleEmailChange = (e) => {
    const value = e.target.value;
    setFormData({ ...formData, email: value });

    // Limpiar errores de email cuando el usuario esté escribiendo
    if (errors.email && value.trim()) {
      setErrors((prev) => ({ ...prev, email: "" }));
    }
  };

  // Maneja cambios en el input de contraseña
  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setFormData({ ...formData, password: value });

    // Limpiar errores de contraseña cuando el usuario esté escribiendo
    if (errors.password && value.trim()) {
      setErrors((prev) => ({ ...prev, password: "" }));
    }
  };

  // Maneja cambios en el input de confirmar contraseña
  const handleConfirmPasswordChange = (e) => {
    const value = e.target.value;
    setFormData({ ...formData, confirmPassword: value });

    // Limpiar errores de confirmación cuando el usuario esté escribiendo
    if (errors.confirmPassword && value.trim()) {
      setErrors((prev) => ({ ...prev, confirmPassword: "" }));
    }
  };

  // Maneja el envío del formulario
  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = validate();
    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      // Aquí puedes manejar el envío del formulario
      dispatch(confirmForgotPassword({ email: formData.email, confirmationCode: otpCode, password: formData.password }));
      console.log("Formulario enviado:", formData);
    } else {
      console.log("Errores de validación:", newErrors);
    }
  };

  // Verifica si todos los campos están completos
  useEffect(() => {
    if (
      otpCode.length === 6 && 
      formData.email.trim() !== "" && 
      formData.password.trim() !== "" && 
      formData.confirmPassword.trim() !== ""
    ) {
      setOtpCodeisComplete(true);
    } else {
      setOtpCodeisComplete(false);
    }

    // Validar en tiempo real cuando el código esté completo pero falte email
    if (otpCode.length === 6 && !formData.email.trim()) {
      setErrors((prev) => ({
        ...prev,
        email: "Por favor, ingresa tu correo electrónico para continuar",
      }));
    }
  }, [otpCode, formData.email, formData.password, formData.confirmPassword]);

  return (
    <main
      id="app-content"
      className="flex flex-col items-center justify-center min-h-screen bg-aw-bgbluedark"
    >
      <div
        id="bck-cooming-soon"
        className="flex flex-col items-center justify-center w-full min-h-screen"
      >
        <div className="relative flex flex-col justify-center gap-y-3 p-4 md:w-2/3 2xl:w-3/7 h-[80dvh] bg-aw-bluedark-75 rounded-lg shadow-lg">
          <Link
            to="/"
            className="absolute top-4 left-4 text-white hover:text-aw-green transition-colors duration-200"
          >
            <FontAwesomeIcon icon="arrow-left" className="mr-2" />
            Volver al Home
          </Link>
          <Link
            onClick={() => dispatch(fpResetConfirmation())}
            to="/forgot-password"
            className="group absolute top-4 right-4 text-white hover:text-amber-400 transition-colors duration-200"
          >
            <FontAwesomeIcon
              icon="fa-solid fa-rotate"
              className="group-hover:animate-spin mr-2"
            />
            Volver a Intentar
          </Link>
          <div className="flex items-center justify-center">
            <LazyLoadImage
              alt="AppWhoop Logo"
              effect="blur"
              wrapperProps={{
                // If you need to, you can tweak the effect transition using the wrapper style.
                style: { transitionDelay: "0.3s" },
              }}
              src={AppWhoopLogo}
              className="w-4/5 sm:w-1/2 xl:w-2/5 object-contain mx-auto"
            />
          </div>
          <div className="flex flex-col text-center items-center justify-center text-white">
            <h2 className="text-xl sm:text-3xl font-bold text-aw-green">
              Confirmar Cambio de Contraseña
            </h2>
            <p className="text-sm text-white">
              Ingresa tu correo electrónico, el código de confirmación y tu nueva contraseña.
            </p>
          </div>
          <div className="flex text-center items-center justify-center">
            {/* Formulario para ingresar correo y código de confirmación para activar usuario */}
            {fpconfirmed == false && fperror == null ? (
              <form
                onSubmit={(e) => {
                  handleSubmit(e);
                }}
                className="w-full max-w-md text-white rounded-lg p-4 shadow-md"
              >
                <div className="">
                  <label
                    htmlFor="email"
                    className="block text-sm font-medium mb-1"
                  >
                    Correo Electrónico
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleEmailChange}
                    className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 text-white placeholder:text-gray-400 ${
                      errors.email
                        ? "border-red-500 focus:ring-red-500"
                        : "border-gray-300 focus:ring-aw-bluedark"
                    }`}
                    placeholder="Ingresa tu correo electrónico"
                  />
                  {errors.email && (
                    <span className="text-xs text-red-400 mt-1 block">
                      {errors.email}
                    </span>
                  )}
                </div>
                <div className="my-4 mx-auto">
                  <label
                    htmlFor="confirmationCode"
                    className="block text-sm font-medium mb-1"
                  >
                    Código de Confirmación
                  </label>
                  <ValidateCode
                    length={6}
                    onComplete={handleOtpComplete}
                    verifyQuantity={setOtpCode}
                    prefillCode={codeFromUrl}
                  />
                  {errors.confirmationCode && (
                    <span className="text-xs text-red-400 mt-1 block text-center">
                      {errors.confirmationCode}
                    </span>
                  )}
                </div>
                {/* Contraseña nueva - 2 inputs para ingresar y confirmar nueva contraseña */}
                <div className="mb-4">
                  <label
                    htmlFor="password"
                    className="block text-sm font-medium mb-1"
                  >
                    Nueva Contraseña
                  </label>
                  <div className="relative">
                    <input
                      ref={passwordInputRef}
                      type={showPassword ? "text" : "password"}
                      id="password"
                      name="password"
                      value={formData.password}
                      onChange={handlePasswordChange}
                      className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 text-white placeholder:text-gray-400 pr-10 ${
                        errors.password
                          ? "border-red-500 focus:ring-red-500"
                          : "border-gray-300 focus:ring-aw-bluedark"
                      }`}
                      placeholder="Ingresa tu nueva contraseña"
                    />
                    <button
                      type="button"
                      className="h-full w-1/12 absolute top-0 right-1 flex justify-center items-center text-gray-400 hover:text-white focus:outline-none duration-200 px-2"
                      onMouseDown={(e) => e.preventDefault()}
                      onClick={() => {
                        const input = passwordInputRef.current;
                        const start = input.selectionStart;
                        const end = input.selectionEnd;
                        setShowPassword((prev) => !prev);
                        setTimeout(() => {
                          input.focus();
                          input.setSelectionRange(start, end);
                        }, 0);
                      }}
                      tabIndex={-1}
                    >
                      <AnimatePresence>
                        <Motion.div
                          key={showPassword ? "eye-slash" : "eye"}
                          initial={{ opacity: 0 }}
                          animate={{ opacity: 1 }}
                          exit={{ opacity: 0 }}
                          transition={{ duration: 0.5 }}
                        >
                          <FontAwesomeIcon
                            icon={
                              showPassword
                                ? "fa-regular fa-eye-slash"
                                : "fa-regular fa-eye"
                            }
                            className="absolute top-3 right-3"
                          />
                        </Motion.div>
                      </AnimatePresence>
                    </button>
                  </div>
                  {errors.password && (
                    <span className="text-xs text-red-400 mt-1 block">
                      {errors.password}
                    </span>
                  )}
                </div>

                <div className="mb-4">
                  <label
                    htmlFor="confirmPassword"
                    className="block text-sm font-medium mb-1"
                  >
                    Confirmar Nueva Contraseña
                  </label>
                  <div className="relative">
                    <input
                      ref={confirmPasswordInputRef}
                      type={showConfirmPassword ? "text" : "password"}
                      id="confirmPassword"
                      name="confirmPassword"
                      value={formData.confirmPassword}
                      onChange={handleConfirmPasswordChange}
                      className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 text-white placeholder:text-gray-400 pr-10 ${
                        errors.confirmPassword
                          ? "border-red-500 focus:ring-red-500"
                          : "border-gray-300 focus:ring-aw-bluedark"
                      }`}
                      placeholder="Confirma tu nueva contraseña"
                    />
                    <button
                      type="button"
                      className="h-full w-1/12 absolute top-0 right-1 flex justify-center items-center text-gray-400 hover:text-white focus:outline-none duration-200 px-2"
                      onMouseDown={(e) => e.preventDefault()}
                      onClick={() => {
                        const input = confirmPasswordInputRef.current;
                        const start = input.selectionStart;
                        const end = input.selectionEnd;
                        setShowConfirmPassword((prev) => !prev);
                        setTimeout(() => {
                          input.focus();
                          input.setSelectionRange(start, end);
                        }, 0);
                      }}
                      tabIndex={-1}
                    >
                      <AnimatePresence>
                        <Motion.div
                          key={showConfirmPassword ? "eye-slash" : "eye"}
                          initial={{ opacity: 0 }}
                          animate={{ opacity: 1 }}
                          exit={{ opacity: 0 }}
                          transition={{ duration: 0.5 }}
                        >
                          <FontAwesomeIcon
                            icon={
                              showConfirmPassword
                                ? "fa-regular fa-eye-slash"
                                : "fa-regular fa-eye"
                            }
                            className="absolute top-3 right-3"
                          />
                        </Motion.div>
                      </AnimatePresence>
                    </button>
                  </div>
                  {errors.confirmPassword && (
                    <span className="text-xs text-red-400 mt-1 block">
                      {errors.confirmPassword}
                    </span>
                  )}
                </div>

                <button
                  type="submit"
                  disabled={!otpCodeisComplete}
                  className="w-full py-2 px-4 disabled:bg-gray-400 disabled:hover:!cursor-not-allowed text-aw-dark font-semibold bg-aw-green rounded-md duration-200"
                >
                  Confirmar Cambio de Contraseña
                </button>
              </form>
            ) : fperror != null ? (
              <div className="w-full max-w-md text-white rounded-lg p-4 shadow-md">
                <FontAwesomeIcon
                  icon="exclamation-circle"
                  size="2xl"
                  className="block text-red-400 mb-2"
                />
                <p className="text-center text-red-400 font-semibold">
                  {fperror.message}
                </p>
                <button
                  onClick={() => dispatch(fpResetConfirmation())}
                  className="bg-aw-green text-aw-bluedark px-4 py-2 font-semibold hover:scale-95 rounded-md mt-4 inline-block text-center transition-scale duration-200"
                >
                  Intentar de Nuevo
                </button>
              </div>
            ) : (
              <div className="w-full max-w-md text-white rounded-lg p-4 shadow-md">
                <p className="text-center text-green-400 font-semibold">
                  ¡Usuario confirmado con éxito! Ya puedes iniciar sesión.
                </p>
                <Link
                  to="/"
                  className="bg-aw-green text-aw-bluedark px-4 py-2 font-semibold hover:scale-95 rounded-md mt-4 inline-block text-center transition-scale duration-200"
                >
                  Regresar al Home
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </main>
  );
}
